import { type GasPayload } from '@atlaskit/analytics-gas-types';

export const onSearchDialogShown = ({
	attributes,
	nonPrivacySafeAttributes,
}: {
	attributes: Record<string, any>;
	nonPrivacySafeAttributes: Record<string, any>;
}): GasPayload => ({
	eventType: 'ui',
	action: 'shown',
	actionSubject: `searchDialog`,
	attributes,
	nonPrivacySafeAttributes,
});
